import React from 'react';
import { useAppDispatch } from '../../../redux/hooks';
import { openAuth } from '../../../redux/slice/authModalSlice';
import { getAuthToken, getUserDisplayName } from '../../../helper/helper';
import './WelcomeSection.scss';

const WelcomeSection: React.FC = () => {
  const dispatch = useAppDispatch();
  const token = getAuthToken();
  const displayName = getUserDisplayName(token);
  const isGuest = !token;

  return (
    <section className="logged-home-welcome">
      {isGuest ? (
        <>
          <h1 className="logged-home-welcome-title">Welcome to CricCenter</h1>
          <p className="logged-home-welcome-subtitle">
            <button type="button" className="logged-home-welcome-link" onClick={() => dispatch(openAuth('signin'))}>
              Login
            </button>
            {' / '}
            <button type="button" className="logged-home-welcome-link" onClick={() => dispatch(openAuth('signup'))}>
              Signup
            </button>
            {' to see more features.'}
          </p>
        </>
      ) : (
        <>
          <h1 className="logged-home-welcome-title">Welcome Back, {displayName}</h1>
          <p className="logged-home-welcome-subtitle">
            Manage Your Leagues, Teams, And Matches In One Place.
          </p>
        </>
      )}
    </section>
  );
};

export default WelcomeSection;
